export default {
  dlState: ['required'],
  dlFrontImage: ['required'],
  dlBackImage: ['required'],
};
